import React, {useContext, useState} from 'react'
import { Box, Button, TextField, Typography } from '@mui/material'
import {NextWindowContext} from "../../../../context/NextWindowContext";
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

interface TestComponentProps {
	data: any;
}

export const TestComponent = ({ data }: TestComponentProps) => {
	const [userAnswer, setUserAnswer] = useState('')
	const [submitted, setSubmitted] = useState(false)
	const [currentQuestion, setCurrentQuestion] = useState(0)
	const nextWindow = useContext(NextWindowContext)
	
	const validationSchema = Yup.object().shape({
		answer: Yup.string()
			.required('Ответ обязателен')
			.min(1, 'Минимальная длина 1 символ')
			.trim(' ')
			.matches(/^[a-zA-Z0-9а-яА-ЯёЁ\s]+$/, 'Ответ должен содержать только буквы и цифры')
	});
	
	const handleSubmit = () => {
		setSubmitted(true)
	}
	
	const handleNextQuestion = () => {
		if (currentQuestion < data.questions.length - 1) {
			setCurrentQuestion(currentQuestion + 1)
			setSubmitted(false)
			setUserAnswer('')
		}
	}
	
	return (
		<Box sx={{
			padding: '20px'
		}}>
			{!submitted ? (
				<Box>
					<Formik
						initialValues={{ answer: '' }}
						validationSchema={validationSchema}
						onSubmit={handleSubmit}
					>
						{({ errors, touched, isSubmitting }) => (
							<Form>
								<Box>
									<Typography sx={{ fontSize: '20px', fontWeight: 800 }}>{data.questions[currentQuestion].question}</Typography>
									<Field as={TextField}
									       name="answer"
									       label='Впишите ответ'
									       variant='outlined'
									       fullWidth
									       multiline
									       rows={4}
									       error={touched.answer && Boolean(errors.answer)}
									       helperText={touched.answer && errors.answer}
									       sx={{ mt: 2 }}
									/>
									<Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
										<Button type="submit" variant="contained" disabled={isSubmitting}>
											{currentQuestion < data.questions.length - 1 ? 'Далее' : 'Завершить'}
										</Button>
									</Box>
								</Box>
							</Form>
						)}
					</Formik>
				</Box>
			) : (
				<Box sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '20px',
					paddingBottom: '150px'
				}}>
					<Box>
						<Typography sx={{fontSize: '18px', color: '#6BD425', fontWeight: 800}}>Правильный ответ:</Typography>
						<Typography sx={{fontSize: '16px'}}>{data.questions[currentQuestion].answer}</Typography>
					</Box>
					<Box>
						<Typography sx={{fontSize: '18px', fontWeight: 800}}>Ваш ответ:</Typography>
						<Typography sx={{fontSize: '16px'}}>{userAnswer}</Typography>
					</Box>
					{currentQuestion < data.questions.length - 1 ? (
						<Box sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							paddingTop: '15px',
							height: '40px'
						}}>
							<Button
								variant="contained"
								onClick={handleNextQuestion}
							>
								Далее
							</Button>
						</Box>
					) : (
						<Box sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							paddingTop: '15px',
							height: '40px'
						}}>
							<Button
								variant="contained"
								onClick={()=>nextWindow()}
							>
								Завершить
							</Button>
						</Box>
					)}
				</Box>
			)}
		</Box>
	)
}
